export default {"src":"/_next/static/media/DocumentsIconCategory.2dd1c699.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};